module.exports = __webpack_public_path__ + "img/1.183bf42b.png";